import 'css-chunk-1JavaScriptSource/components/_Dialogs/preview-artwork-dialog/style.module.scss';export default {
  "previewContainer": "_previewContainer_1onut_5",
  "toolbar": "_toolbar_1onut_22",
  "colourSpaceWarning": "_colourSpaceWarning_1onut_27",
  "previewWrapper": "_previewWrapper_1onut_36",
  "previewPanelList": "_previewPanelList_1onut_42",
  "previewIframeContainer": "_previewIframeContainer_1onut_58",
  "previewIframe": "_previewIframe_1onut_58",
  "previewErrors": "_previewErrors_1onut_66"
};